import React from 'react';

const SvgOverviewFrame = () => (
  <React.Fragment>
    <path
      d='M320 234v1146.5h296.04v-306.59H858.5'
      style={{
        fill: 'none',
        paintOrder: 'normal',
        strokeLinejoin: 'round',
        strokeMiterlimit: 20,
        strokeWidth: 8,
        stroke: '#0af'
      }}
    />
    <path
      d='M887.02 729H606v641.13h279.9'
      style={{
        fill: 'none',
        paintOrder: 'normal',
        strokeLinejoin: 'round',
        strokeMiterlimit: 20,
        strokeWidth: 8,
        stroke: '#00b200'
      }}
    />
    <path
      d='M330 236.2v933.43h139.19V719.02h417.88'
      style={{
        fill: 'none',
        paintOrder: 'normal',
        strokeLinejoin: 'round',
        strokeMiterlimit: 20,
        strokeWidth: 8,
        stroke: 'red'
      }}
    />
    <path
      d='M757.46 966.64v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V966.64a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093zM786.46 626.64v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V626.64a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093zM730.46 626.64v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V626.64a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M223.69 220.55h182.63c1.74 0 3.141 1.371 3.141 3.075v17.76c0 1.703-1.4 3.075-3.141 3.075H223.69c-1.74 0-3.141-1.372-3.141-3.075v-17.76c0-1.704 1.4-3.075 3.141-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 223h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 119.21)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={11}
    >
      <path d='M132.97 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.211v10.484h2.375zM143.14 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.21v10.484h2.376z' />
    </g>
    <path
      d='M223.71 1087.5h182.58c1.752 0 3.163 1.371 3.163 3.075v17.76c0 1.703-1.41 3.075-3.163 3.075H223.71c-1.752 0-3.163-1.372-3.163-3.075v-17.76c0-1.704 1.41-3.075 3.163-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 1090h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 986.21)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={27}
    >
      <path d='M133.63 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258zM143.84 111.71l-5.266 9.89h-1.672l5.602-10.265h-6.625v-1.368h7.961z' />
    </g>
    <path
      d='M453.46 1068.1v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V1068.1a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M434.14 1067.5h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H434.14a2.121 2.121 0 0 1-2.126-2.126v-14.559c0-1.178.948-2.126 2.126-2.126z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68365
      }}
    />
    <g
      transform='matrix(.87979 0 0 .9764 322.86 964.54)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={44}
    >
      <path d='M133.9 118.32h-1.727v3.273h-1.5v-3.273h-5.57v-1.797l5.633-6.562h1.437v7.109h1.727zm-3.227-1.25v-5.25l-4.507 5.25zM144.07 118.32h-1.727v3.273h-1.5v-3.273h-5.57v-1.797l5.633-6.562h1.437v7.109h1.727zm-3.227-1.25v-5.25l-4.507 5.25z' />
    </g>
    <path
      d='M507.46 617.64v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V617.64a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M488.14 617h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H488.14a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 376.86 514.01)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-4)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={45}
    >
      <path d='M133.9 118.32h-1.727v3.273h-1.5v-3.273h-5.57v-1.797l5.633-6.562h1.437v7.109h1.727zm-3.227-1.25v-5.25l-4.507 5.25zM143.71 117.9q0 .813-.297 1.555t-.812 1.25q-.563.547-1.344.843-.774.29-1.797.29-.953 0-1.836-.204-.883-.195-1.492-.476v-1.649h.11q.64.407 1.5.696.859.281 1.687.281.554 0 1.07-.156.523-.157.93-.547.343-.336.515-.805.18-.469.18-1.086 0-.601-.21-1.015-.204-.414-.571-.664-.406-.297-.992-.414-.579-.125-1.297-.125-.688 0-1.328.093-.633.094-1.094.188v-5.992h7v1.367h-5.492v3.094q.336-.032.687-.047.352-.016.61-.016.945 0 1.656.164.71.156 1.304.563.625.43.97 1.109t.343 1.703z' />
    </g>
    <path
      d='M480.46 1277.6v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V1277.6a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M461.13 1277.2h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H461.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 349.85 1173.4)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-9)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={30}
    >
      <path d='M132.61 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.789.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.118q.664.438 1.562.727.898.29 1.734.29.493 0 1.047-.165.555-.164.899-.484.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156t1.172.5q.562.375.851.906t.29 1.242q0 .969-.688 1.696-.68.718-1.61.906v.11q.376.062.86.265.484.195.82.492zM143.79 115.78q0 3.133-.984 4.602-.977 1.46-3.04 1.46-2.093 0-3.062-1.484-.96-1.484-.96-4.562 0-3.102.976-4.578.976-1.485 3.047-1.485 2.093 0 3.054 1.508.969 1.5.969 4.539zm-2.055 3.547q.274-.633.367-1.485.102-.859.102-2.062 0-1.188-.102-2.063-.093-.874-.375-1.484-.273-.601-.75-.906-.468-.305-1.21-.305-.735 0-1.22.305-.476.305-.757.922-.266.578-.367 1.508-.094.93-.094 2.039 0 1.218.086 2.039t.367 1.469q.258.609.727.93.476.32 1.258.32.734 0 1.218-.305.485-.305.75-.922z' />
    </g>
    <path
      d='M898.46 1268.6v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V1268.6a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M879.14 1268h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H879.14a2.121 2.121 0 0 1-2.126-2.126v-14.559c0-1.178.948-2.126 2.126-2.126z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 767.86 1164.2)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-9-8)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={51}
    >
      <path d='M133.54 117.9q0 .813-.297 1.555t-.812 1.25q-.563.547-1.344.843-.774.29-1.797.29-.953 0-1.836-.204-.883-.195-1.492-.476v-1.649h.11q.64.407 1.5.696.859.281 1.687.281.554 0 1.07-.156.523-.157.93-.547.343-.336.515-.805.18-.469.18-1.086 0-.601-.21-1.015-.204-.414-.571-.664-.407-.297-.992-.414-.579-.125-1.297-.125-.688 0-1.328.093-.633.094-1.094.188v-5.992h7v1.367h-5.492v3.094q.336-.032.687-.047.352-.016.61-.016.945 0 1.656.164.71.156 1.304.563.625.43.97 1.109t.343 1.703zM143.14 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.21v10.484h2.376z' />
    </g>
    <path
      d='M813.46 966.64v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V966.64a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M794.14 966.5h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H794.14a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 682.86 862.71)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-9-8-7)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={34}
    >
      <path d='M132.61 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.789.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.118q.664.438 1.562.727.898.29 1.734.29.493 0 1.047-.165.555-.164.899-.484.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156t1.172.5q.562.375.851.906t.29 1.242q0 .969-.688 1.696-.68.718-1.61.906v.11q.376.062.86.265.484.195.82.492zM144.07 118.32h-1.727v3.273h-1.5v-3.273h-5.57v-1.797l5.633-6.562h1.437v7.109h1.727zm-3.227-1.25v-5.25l-4.507 5.25z' />
    </g>
    <path
      d='M738.14 966.5h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H738.14a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 626.86 862.7)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-9-8-7-4)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={33}
    >
      <path d='M132.61 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.789.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.118q.664.438 1.562.727.898.29 1.734.29.493 0 1.047-.165.555-.164.899-.484.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156t1.172.5q.562.375.851.906t.29 1.242q0 .969-.688 1.696-.68.718-1.61.906v.11q.376.062.86.265.484.195.82.492zM142.78 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.79.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.117q.665.438 1.563.727t1.734.29q.493 0 1.047-.165t.899-.484q.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156.648.156 1.172.5.562.375.851.906.29.531.29 1.242 0 .969-.688 1.696-.68.718-1.61.906v.11q.375.062.86.265.484.195.82.492z' />
    </g>
    <path
      d='M869.46 966.64v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V966.64a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M850.14 966.5h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H850.14a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 738.86 862.71)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-9-8-7-9)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={35}
    >
      <path d='M132.61 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.789.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.118q.664.438 1.562.727.898.29 1.734.29.493 0 1.047-.165.555-.164.899-.484.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156t1.172.5q.562.375.851.906t.29 1.242q0 .969-.688 1.696-.68.718-1.61.906v.11q.376.062.86.265.484.195.82.492zM143.71 117.9q0 .813-.297 1.555t-.812 1.25q-.563.547-1.344.843-.774.29-1.797.29-.953 0-1.836-.204-.883-.195-1.492-.476v-1.649h.11q.64.407 1.5.696.859.281 1.687.281.554 0 1.07-.156.523-.157.93-.547.343-.336.515-.805.18-.469.18-1.086 0-.601-.21-1.015-.204-.414-.571-.664-.406-.297-.992-.414-.579-.125-1.297-.125-.688 0-1.328.093-.633.094-1.094.188v-5.992h7v1.367h-5.492v3.094q.336-.032.687-.047.352-.016.61-.016.945 0 1.656.164.71.156 1.304.563.625.43.97 1.109t.343 1.703z' />
    </g>
    <path
      d='M842.46 1268.6v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V1268.6a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M823.14 1268h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H823.14a2.121 2.121 0 0 1-2.126-2.126v-14.559c0-1.178.948-2.126 2.126-2.126z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 711.86 1164.2)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-9-8-6)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={50}
    >
      <path d='M133.54 117.9q0 .813-.297 1.555t-.812 1.25q-.563.547-1.344.843-.774.29-1.797.29-.953 0-1.836-.204-.883-.195-1.492-.476v-1.649h.11q.64.407 1.5.696.859.281 1.687.281.554 0 1.07-.156.523-.157.93-.547.343-.336.515-.805.18-.469.18-1.086 0-.601-.21-1.015-.204-.414-.571-.664-.407-.297-.992-.414-.579-.125-1.297-.125-.688 0-1.328.093-.633.094-1.094.188v-5.992h7v1.367h-5.492v3.094q.336-.032.687-.047.352-.016.61-.016.945 0 1.656.164.71.156 1.304.563.625.43.97 1.109t.343 1.703zM143.79 115.78q0 3.133-.984 4.602-.977 1.46-3.04 1.46-2.093 0-3.062-1.484-.96-1.484-.96-4.562 0-3.102.976-4.578.976-1.485 3.047-1.485 2.093 0 3.054 1.508.969 1.5.969 4.539zm-2.055 3.547q.274-.633.367-1.485.102-.859.102-2.062 0-1.188-.102-2.063-.093-.874-.375-1.484-.273-.601-.75-.906-.468-.305-1.21-.305-.735 0-1.22.305-.476.305-.757.922-.266.578-.367 1.508-.094.93-.094 2.039 0 1.218.086 2.039t.367 1.469q.258.609.727.93.476.32 1.258.32.734 0 1.218-.305.485-.305.75-.922z' />
    </g>
    <path
      d='M786.46 1268.6v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V1268.6a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M767.14 1268h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H767.14a2.121 2.121 0 0 1-2.126-2.126v-14.559c0-1.178.948-2.126 2.126-2.126z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 655.86 1164.2)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-9-8-6-9)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={48}
    >
      <path d='M133.9 118.32h-1.727v3.273h-1.5v-3.273h-5.57v-1.797l5.633-6.562h1.437v7.109h1.727zm-3.227-1.25v-5.25l-4.507 5.25zM143.89 118.36q0 1.508-1.18 2.508-1.172 1-2.953 1-1.89 0-3.015-.977-1.118-.976-1.118-2.5 0-.969.563-1.75.562-.789 1.586-1.25v-.047q-.938-.5-1.39-1.093-.446-.594-.446-1.485 0-1.312 1.078-2.187t2.742-.875q1.742 0 2.781.836 1.04.836 1.04 2.125 0 .789-.493 1.554-.492.758-1.445 1.188v.047q1.094.468 1.672 1.156.578.687.578 1.75zm-1.852-5.68q0-.836-.648-1.328-.64-.5-1.64-.5-.985 0-1.618.469-.625.469-.625 1.266 0 .562.313.976.32.406.96.727.29.14.829.367.547.226 1.062.375.774-.516 1.07-1.07.297-.555.297-1.282zm.243 5.828q0-.718-.32-1.148-.313-.437-1.235-.875-.367-.172-.805-.32-.437-.149-1.164-.414-.703.382-1.133 1.039-.422.656-.422 1.484 0 1.055.727 1.742.727.688 1.844.688 1.14 0 1.82-.586.688-.586.688-1.61z' />
    </g>
    <path
      d='M730.46 1268.6v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V1268.6a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M711.14 1268h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H711.14a2.121 2.121 0 0 1-2.126-2.126v-14.559c0-1.178.948-2.126 2.126-2.126z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 599.86 1164.2)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-9-8-6-9-7)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={47}
    >
      <path d='M133.9 118.32h-1.727v3.273h-1.5v-3.273h-5.57v-1.797l5.633-6.562h1.437v7.109h1.727zm-3.227-1.25v-5.25l-4.507 5.25zM143.84 111.71l-5.266 9.89h-1.672l5.602-10.265h-6.625v-1.368h7.961z' />
    </g>
    <path
      d='M898.46 626.64v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V626.64a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M879.14 626.5h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H879.14a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 767.86 522.7)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-9-8-9)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={43}
    >
      <path d='M133.9 118.32h-1.727v3.273h-1.5v-3.273h-5.57v-1.797l5.633-6.562h1.437v7.109h1.727zm-3.227-1.25v-5.25l-4.507 5.25zM142.78 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.79.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.117q.665.438 1.563.727t1.734.29q.493 0 1.047-.165t.899-.484q.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156.648.156 1.172.5.562.375.851.906.29.531.29 1.242 0 .969-.688 1.696-.68.718-1.61.906v.11q.375.062.86.265.484.195.82.492z' />
    </g>
    <path
      d='M842.46 626.64v182.72a3.077 3.077 0 0 1-3.075 3.093h-17.76a3.077 3.077 0 0 1-3.075-3.093V626.64a3.077 3.077 0 0 1 3.075-3.093h17.76a3.077 3.077 0 0 1 3.075 3.093z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M823.14 626.5h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H823.14a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 711.86 522.7)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-9-8-6-3)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={41}
    >
      <path d='M133.9 118.32h-1.727v3.273h-1.5v-3.273h-5.57v-1.797l5.633-6.562h1.437v7.109h1.727zm-3.227-1.25v-5.25l-4.507 5.25zM143.14 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.21v10.484h2.376z' />
    </g>
    <path
      d='M767.24 626.5h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H767.24a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 655.96 522.7)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-9-8-6-9-4)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={40}
    >
      <path d='M133.9 118.32h-1.727v3.273h-1.5v-3.273h-5.57v-1.797l5.633-6.562h1.437v7.109h1.727zm-3.227-1.25v-5.25l-4.507 5.25zM143.79 115.78q0 3.133-.984 4.602-.977 1.46-3.04 1.46-2.093 0-3.062-1.484-.96-1.484-.96-4.562 0-3.102.976-4.578.976-1.485 3.047-1.485 2.093 0 3.054 1.508.969 1.5.969 4.539zm-2.055 3.547q.274-.633.367-1.485.102-.859.102-2.062 0-1.188-.102-2.063-.093-.874-.375-1.484-.273-.601-.75-.906-.468-.305-1.21-.305-.735 0-1.22.305-.476.305-.757.922-.266.578-.367 1.508-.094.93-.094 2.039 0 1.218.086 2.039t.367 1.469q.258.609.727.93.476.32 1.258.32.734 0 1.218-.305.485-.305.75-.922z' />
    </g>
    <path
      d='M711.14 626.5h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H711.14a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 599.86 522.7)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-5-9-8-6-9-7-3)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={39}
    >
      <path d='M132.61 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.789.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.118q.664.438 1.562.727.898.29 1.734.29.493 0 1.047-.165.555-.164.899-.484.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156t1.172.5q.562.375.851.906t.29 1.242q0 .969-.688 1.696-.68.718-1.61.906v.11q.376.062.86.265.484.195.82.492zM143.79 115.08q0 1.523-.352 2.766-.343 1.242-1.046 2.117-.711.89-1.782 1.375-1.07.484-2.515.484-.407 0-.766-.047-.36-.039-.64-.133v-1.492h.078q.226.117.64.227.414.101.922.101 1.727 0 2.703-1.03.985-1.04 1.14-2.86-.726.437-1.366.625-.641.187-1.399.187-.719 0-1.305-.14-.578-.14-1.164-.547-.687-.477-1.039-1.211-.343-.734-.343-1.758 0-1.781 1.171-2.898t2.86-1.117q.844 0 1.562.265.72.258 1.258.781.664.649 1.024 1.672.359 1.016.359 2.633zm-1.578-.336q0-1.21-.25-1.945-.25-.735-.688-1.14-.367-.352-.789-.5-.422-.157-.914-.157-1.125 0-1.78.703-.65.703-.65 1.977 0 .742.212 1.21t.71.82q.352.243.774.329.422.078.937.078.61 0 1.235-.164t1.172-.477l.015-.32q.016-.164.016-.414z' />
    </g>
    <path
      d='M218.31 1268.5h182.37c1.81 0 3.268 1.371 3.268 3.075v17.76c0 1.703-1.457 3.074-3.268 3.074H218.31c-1.81 0-3.268-1.371-3.268-3.074v-17.76c0-1.704 1.457-3.075 3.268-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0909,
        stroke: '#000'
      }}
    />
    <path
      d='M219.63 1271h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H219.63a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 108.35 1167.2)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-3)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={28}
    >
      <path d='M133.63 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258zM143.89 118.36q0 1.508-1.18 2.508-1.172 1-2.953 1-1.89 0-3.015-.977-1.118-.976-1.118-2.5 0-.969.563-1.75.562-.789 1.586-1.25v-.047q-.938-.5-1.39-1.093-.446-.594-.446-1.485 0-1.312 1.078-2.187t2.742-.875q1.742 0 2.781.836 1.04.836 1.04 2.125 0 .789-.493 1.554-.492.758-1.445 1.188v.047q1.094.468 1.672 1.156.578.687.578 1.75zm-1.852-5.68q0-.836-.648-1.328-.64-.5-1.64-.5-.985 0-1.618.469-.625.469-.625 1.266 0 .562.313.976.32.406.96.727.29.14.829.367.547.226 1.062.375.774-.516 1.07-1.07.297-.555.297-1.282zm.243 5.828q0-.718-.32-1.148-.313-.437-1.235-.875-.367-.172-.805-.32-.437-.149-1.164-.414-.703.382-1.133 1.039-.422.656-.422 1.484 0 1.055.727 1.742.727.688 1.844.688 1.14 0 1.82-.586.688-.586.688-1.61z' />
    </g>
    <path
      d='M223.71 271.55H406.3c1.751 0 3.16 1.371 3.16 3.075v17.76c0 1.703-1.409 3.075-3.16 3.075H223.71c-1.751 0-3.16-1.372-3.16-3.075v-17.76c0-1.704 1.409-3.075 3.16-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 274.1h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 170.31)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-2)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={12}
    >
      <path d='M132.97 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.211v10.484h2.375zM143.8 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258z' />
    </g>
    <path
      d='M223.71 424.55h182.58c1.752 0 3.162 1.371 3.162 3.075v17.76c0 1.703-1.41 3.075-3.162 3.075H223.71c-1.752 0-3.162-1.372-3.162-3.075v-17.76c0-1.704 1.41-3.075 3.162-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 427.3h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 323.5)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-5)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={14}
    >
      <path d='M132.97 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.211v10.484h2.375zM144.07 118.32h-1.727v3.273h-1.5v-3.273h-5.57v-1.797l5.633-6.562h1.437v7.109h1.727zm-3.227-1.25v-5.25l-4.507 5.25z' />
    </g>
    <path
      d='M223.71 475.55h182.58c1.752 0 3.162 1.371 3.162 3.075v17.76c0 1.703-1.41 3.075-3.162 3.075H223.71c-1.752 0-3.162-1.372-3.162-3.075v-17.76c0-1.704 1.41-3.075 3.162-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 478h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 374.21)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-2-4)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={15}
    >
      <path d='M132.97 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.211v10.484h2.375zM143.71 117.9q0 .813-.297 1.555t-.812 1.25q-.563.547-1.344.843-.774.29-1.797.29-.953 0-1.836-.204-.883-.195-1.492-.476v-1.649h.11q.64.407 1.5.696.859.281 1.687.281.554 0 1.07-.156.523-.157.93-.547.343-.336.515-.805.18-.469.18-1.086 0-.601-.21-1.015-.204-.414-.571-.664-.406-.297-.992-.414-.579-.125-1.297-.125-.688 0-1.328.093-.633.094-1.094.188v-5.992h7v1.367h-5.492v3.094q.336-.032.687-.047.352-.016.61-.016.945 0 1.656.164.71.156 1.304.563.625.43.97 1.109t.343 1.703z' />
    </g>
    <path
      d='M223.71 322.55H406.3c1.751 0 3.16 1.371 3.16 3.075v17.76c0 1.703-1.409 3.075-3.16 3.075H223.71c-1.751 0-3.16-1.372-3.16-3.075v-17.76c0-1.704 1.409-3.075 3.16-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 325.2h17.031c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.559c0-1.178.948-2.126 2.126-2.126z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.72715
      }}
    />
    <g
      transform='matrix(.63452 0 0 .97638 144.28 221.4)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-8)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label='13A'
    >
      <path d='M132.97 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.211v10.484h2.375zM142.78 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.79.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.117q.665.438 1.563.727t1.734.29q.493 0 1.047-.165t.899-.484q.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156.648.156 1.172.5.562.375.851.906.29.531.29 1.242 0 .969-.688 1.696-.68.718-1.61.906v.11q.375.062.86.265.484.195.82.492zM155.58 121.6h-1.648l-1.141-3.242h-5.031l-1.14 3.242h-1.571l4.234-11.633h2.063zm-3.266-4.57-2.039-5.711-2.047 5.71z' />
    </g>
    <path
      d='M223.71 373.55h182.58c1.752 0 3.162 1.371 3.162 3.075v17.76c0 1.703-1.41 3.075-3.162 3.075H223.71c-1.752 0-3.162-1.372-3.162-3.075v-17.76c0-1.704 1.41-3.075 3.162-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 376.3h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.559c0-1.178.948-2.126 2.126-2.126z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 272.61)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-2-5)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={13}
    >
      <path d='M132.97 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.211v10.484h2.375zM142.78 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.79.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.117q.665.438 1.563.727t1.734.29q.493 0 1.047-.165t.899-.484q.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156.648.156 1.172.5.562.375.851.906.29.531.29 1.242 0 .969-.688 1.696-.68.718-1.61.906v.11q.375.062.86.265.484.195.82.492z' />
    </g>
    <path
      d='M223.71 577.55h182.58c1.752 0 3.162 1.371 3.162 3.075v17.76c0 1.703-1.41 3.075-3.162 3.075H223.71c-1.752 0-3.162-1.372-3.162-3.075v-17.76c0-1.704 1.41-3.075 3.162-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 580.1h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.559c0-1.178.948-2.126 2.126-2.126z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 476.31)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-5-2)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={17}
    >
      <path d='M132.97 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.211v10.484h2.375zM143.84 111.71l-5.266 9.89h-1.672l5.602-10.265h-6.625v-1.368h7.961z' />
    </g>
    <path
      d='M223.71 628.55h182.58c1.752 0 3.162 1.372 3.162 3.076v17.766c0 1.704-1.41 3.076-3.162 3.076H223.71c-1.752 0-3.162-1.372-3.162-3.076v-17.766c0-1.704 1.41-3.076 3.162-3.076z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.091,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 631.1h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 527.3)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-2-4-3)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={18}
    >
      <path d='M132.97 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.211v10.484h2.375zM143.89 118.36q0 1.508-1.18 2.508-1.172 1-2.953 1-1.89 0-3.015-.977-1.118-.976-1.118-2.5 0-.969.563-1.75.562-.789 1.586-1.25v-.047q-.938-.5-1.39-1.093-.446-.594-.446-1.485 0-1.312 1.078-2.187t2.742-.875q1.742 0 2.781.836 1.04.836 1.04 2.125 0 .789-.493 1.554-.492.758-1.445 1.188v.047q1.094.468 1.672 1.156.578.687.578 1.75zm-1.852-5.68q0-.836-.648-1.328-.64-.5-1.64-.5-.985 0-1.618.469-.625.469-.625 1.266 0 .562.313.976.32.406.96.727.29.14.829.367.547.226 1.062.375.774-.516 1.07-1.07.297-.555.297-1.282zm.243 5.828q0-.718-.32-1.148-.313-.437-1.235-.875-.367-.172-.805-.32-.437-.149-1.164-.414-.703.382-1.133 1.039-.422.656-.422 1.484 0 1.055.727 1.742.727.688 1.844.688 1.14 0 1.82-.586.688-.586.688-1.61z' />
    </g>
    <path
      d='M223.71 526.55h182.58c1.752 0 3.162 1.371 3.162 3.075v17.76c0 1.703-1.41 3.075-3.162 3.075H223.71c-1.752 0-3.162-1.372-3.162-3.075v-17.76c0-1.704 1.41-3.075 3.162-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 529h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 425.2)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-2-5-0)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={16}
    >
      <path d='M132.97 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.211v10.484h2.375zM143.98 117.82q0 1.773-1.172 2.898-1.164 1.118-2.86 1.118-.859 0-1.562-.266-.703-.266-1.242-.79-.672-.648-1.04-1.718-.358-1.07-.358-2.578 0-1.547.328-2.742.336-1.195 1.062-2.125.688-.883 1.774-1.375 1.085-.5 2.53-.5.462 0 .774.039t.633.14v1.493h-.078q-.219-.117-.664-.219-.438-.11-.899-.11-1.68 0-2.68 1.055-1 1.047-1.163 2.836.656-.398 1.289-.601.64-.211 1.476-.211.742 0 1.305.14.57.133 1.164.547.688.477 1.031 1.203.352.727.352 1.766zm-1.586.063q0-.727-.219-1.204-.21-.476-.703-.828-.36-.25-.797-.328-.437-.078-.914-.078-.664 0-1.234.156-.57.157-1.172.485-.016.172-.023.336-.008.156-.008.398 0 1.234.25 1.953.257.711.703 1.125.36.344.773.508.422.156.914.156 1.133 0 1.781-.687.649-.696.649-1.992z' />
    </g>
    <path
      d='M223.71 730.55H406.3c1.751 0 3.161 1.371 3.161 3.075v17.76c0 1.703-1.41 3.074-3.161 3.074H223.71c-1.751 0-3.161-1.37-3.161-3.074v-17.76c0-1.704 1.41-3.075 3.161-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 733h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 629.2)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-5-1)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={20}
    >
      <path d='M133.63 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258zM143.79 115.78q0 3.133-.984 4.602-.977 1.46-3.04 1.46-2.093 0-3.062-1.484-.96-1.484-.96-4.562 0-3.102.976-4.578.976-1.485 3.047-1.485 2.093 0 3.054 1.508.969 1.5.969 4.539zm-2.055 3.547q.274-.633.367-1.485.102-.859.102-2.062 0-1.188-.102-2.063-.093-.874-.375-1.484-.273-.601-.75-.906-.468-.305-1.21-.305-.735 0-1.22.305-.476.305-.757.922-.266.578-.367 1.508-.094.93-.094 2.039 0 1.218.086 2.039t.367 1.469q.258.609.727.93.476.32 1.258.32.734 0 1.218-.305.485-.305.75-.922z' />
    </g>
    <path
      d='M223.71 781.55H406.3c1.751 0 3.161 1.371 3.161 3.075v17.76c0 1.703-1.41 3.075-3.161 3.075H223.71c-1.751 0-3.161-1.372-3.161-3.075v-17.76c0-1.704 1.41-3.075 3.161-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 784.1h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 680.31)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-2-4-7)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={21}
    >
      <path d='M133.63 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258zM143.14 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.21v10.484h2.376z' />
    </g>
    <path
      d='M223.71 679.55h182.58c1.752 0 3.162 1.371 3.162 3.075v17.76c0 1.703-1.41 3.075-3.162 3.075H223.71c-1.752 0-3.162-1.372-3.162-3.075v-17.76c0-1.704 1.41-3.075 3.162-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 682.1h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.559c0-1.178.948-2.126 2.126-2.126z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 578.31)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-2-5-2)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={19}
    >
      <path d='M132.97 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.211v10.484h2.375zM143.79 115.08q0 1.523-.352 2.766-.343 1.242-1.046 2.117-.711.89-1.782 1.375-1.07.484-2.515.484-.407 0-.766-.047-.36-.039-.64-.133v-1.492h.078q.226.117.64.227.414.101.922.101 1.727 0 2.703-1.03.985-1.04 1.14-2.86-.726.437-1.366.625-.641.187-1.399.187-.719 0-1.305-.14-.578-.14-1.164-.547-.687-.477-1.039-1.211-.343-.734-.343-1.758 0-1.781 1.171-2.898t2.86-1.117q.844 0 1.562.265.72.258 1.258.781.664.649 1.024 1.672.359 1.016.359 2.633zm-1.578-.336q0-1.21-.25-1.945-.25-.735-.688-1.14-.367-.352-.789-.5-.422-.157-.914-.157-1.125 0-1.78.703-.65.703-.65 1.977 0 .742.212 1.21t.71.82q.352.243.774.329.422.078.937.078.61 0 1.235-.164t1.172-.477l.015-.32q.016-.164.016-.414z' />
    </g>
    <path
      d='M223.71 883.55h182.58c1.752 0 3.163 1.371 3.163 3.075v17.76c0 1.703-1.41 3.075-3.163 3.075H223.71c-1.752 0-3.163-1.372-3.163-3.075v-17.76c0-1.704 1.41-3.075 3.163-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 886.1h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 782.31)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-5-2-4)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={23}
    >
      <path d='M133.63 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258zM142.78 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.79.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.117q.665.438 1.563.727t1.734.29q.493 0 1.047-.165t.899-.484q.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156.648.156 1.172.5.562.375.851.906.29.531.29 1.242 0 .969-.688 1.696-.68.718-1.61.906v.11q.375.062.86.265.484.195.82.492z' />
    </g>
    <path
      d='M223.71 934.55h182.58c1.752 0 3.163 1.371 3.163 3.075v17.76c0 1.703-1.41 3.075-3.163 3.075H223.71c-1.752 0-3.163-1.372-3.163-3.075v-17.76c0-1.704 1.41-3.075 3.163-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 937.1h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 833.3)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-2-4-3-9)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={24}
    >
      <path d='M133.63 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258zM144.07 118.32h-1.727v3.273h-1.5v-3.273h-5.57v-1.797l5.633-6.562h1.437v7.109h1.727zm-3.227-1.25v-5.25l-4.507 5.25z' />
    </g>
    <path
      d='M223.71 985.55h182.58c1.752 0 3.163 1.371 3.163 3.075v17.759c0 1.703-1.41 3.075-3.163 3.075H223.71c-1.752 0-3.163-1.372-3.163-3.075v-17.76c0-1.703 1.41-3.074 3.163-3.074z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 988h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 884.21)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-5-2-4-7)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={25}
    >
      <path d='M133.63 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258zM143.71 117.9q0 .813-.297 1.555t-.812 1.25q-.563.547-1.344.843-.774.29-1.797.29-.953 0-1.836-.204-.883-.195-1.492-.476v-1.649h.11q.64.407 1.5.696.859.281 1.687.281.554 0 1.07-.156.523-.157.93-.547.343-.336.515-.805.18-.469.18-1.086 0-.601-.21-1.015-.204-.414-.571-.664-.406-.297-.992-.414-.579-.125-1.297-.125-.688 0-1.328.093-.633.094-1.094.188v-5.992h7v1.367h-5.492v3.094q.336-.032.687-.047.352-.016.61-.016.945 0 1.656.164.71.156 1.304.563.625.43.97 1.109t.343 1.703z' />
    </g>
    <path
      d='M223.71 1036.5h182.58c1.752 0 3.163 1.371 3.163 3.075v17.76c0 1.703-1.41 3.075-3.163 3.075H223.71c-1.752 0-3.163-1.372-3.163-3.075v-17.76c0-1.704 1.41-3.075 3.163-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 1039.1h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 935.3)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-2-4-3-9-7)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={26}
    >
      <path d='M133.63 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258zM143.98 117.82q0 1.773-1.172 2.898-1.164 1.118-2.86 1.118-.859 0-1.562-.266-.703-.266-1.242-.79-.672-.648-1.04-1.718-.358-1.07-.358-2.578 0-1.547.328-2.742.336-1.195 1.062-2.125.688-.883 1.774-1.375 1.085-.5 2.53-.5.462 0 .774.039t.633.14v1.493h-.078q-.219-.117-.664-.219-.438-.11-.899-.11-1.68 0-2.68 1.055-1 1.047-1.163 2.836.656-.398 1.289-.601.64-.211 1.476-.211.742 0 1.305.14.57.133 1.164.547.688.477 1.031 1.203.352.727.352 1.766zm-1.586.063q0-.727-.219-1.204-.21-.476-.703-.828-.36-.25-.797-.328-.437-.078-.914-.078-.664 0-1.234.156-.57.157-1.172.485-.016.172-.023.336-.008.156-.008.398 0 1.234.25 1.953.257.711.703 1.125.36.344.773.508.422.156.914.156 1.133 0 1.781-.687.649-.696.649-1.992z' />
    </g>
    <path
      d='M223.71 832.55h182.58c1.752 0 3.163 1.371 3.163 3.075v17.76c0 1.703-1.41 3.075-3.163 3.075H223.71c-1.752 0-3.163-1.372-3.163-3.075v-17.76c0-1.704 1.41-3.075 3.163-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0908,
        stroke: '#000'
      }}
    />
    <path
      d='M225.13 835.1h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H225.13a2.121 2.121 0 0 1-2.126-2.126v-14.559c0-1.178.948-2.126 2.126-2.126z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 113.85 731.3)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-2-5-0-2)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={22}
    >
      <path d='M133.63 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258zM143.8 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258z' />
    </g>
    <path
      d='M218.31 1319.5h182.37c1.81 0 3.268 1.371 3.268 3.075v17.759c0 1.703-1.457 3.075-3.268 3.075H218.31c-1.81 0-3.268-1.372-3.268-3.075v-17.76c0-1.702 1.457-3.074 3.268-3.074z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0909,
        stroke: '#000'
      }}
    />
    <path
      d='M219.63 1322h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H219.63a2.121 2.121 0 0 1-2.126-2.126v-14.559c0-1.178.948-2.126 2.126-2.126z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 108.35 1218.2)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-3-9)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={29}
    >
      <path d='M133.63 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258zM143.79 115.08q0 1.523-.352 2.766-.343 1.242-1.046 2.117-.711.89-1.782 1.375-1.07.484-2.515.484-.407 0-.766-.047-.36-.039-.64-.133v-1.492h.078q.226.117.64.227.414.101.922.101 1.727 0 2.703-1.03.985-1.04 1.14-2.86-.726.437-1.366.625-.641.187-1.399.187-.719 0-1.305-.14-.578-.14-1.164-.547-.687-.477-1.039-1.211-.343-.734-.343-1.758 0-1.781 1.171-2.898t2.86-1.117q.844 0 1.562.265.72.258 1.258.781.664.649 1.024 1.672.359 1.016.359 2.633zm-1.578-.336q0-1.21-.25-1.945-.25-.735-.688-1.14-.367-.352-.789-.5-.422-.157-.914-.157-1.125 0-1.78.703-.65.703-.65 1.977 0 .742.212 1.21t.71.82q.352.243.774.329.422.078.937.078.61 0 1.235-.164t1.172-.477l.015-.32q.016-.164.016-.414z' />
    </g>
    <path
      d='M509.64 1232.5h182.72a3.077 3.077 0 0 1 3.093 3.075v17.76a3.077 3.077 0 0 1-3.093 3.075H509.64a3.077 3.077 0 0 1-3.093-3.075v-17.76a3.077 3.077 0 0 1 3.093-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M511.13 1235h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H511.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 399.85 1131.2)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-3-9-2)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={31}
    >
      <path d='M132.61 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.789.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.118q.664.438 1.562.727.898.29 1.734.29.493 0 1.047-.165.555-.164.899-.484.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156t1.172.5q.562.375.851.906t.29 1.242q0 .969-.688 1.696-.68.718-1.61.906v.11q.376.062.86.265.484.195.82.492zM143.14 121.6h-6.297v-1.188h2.422v-7.796h-2.422v-1.063q.492 0 1.055-.078.562-.086.851-.242.36-.196.563-.492.21-.305.242-.813h1.21v10.484h2.376z' />
    </g>
    <path
      d='M509.64 1181.5h182.72a3.077 3.077 0 0 1 3.093 3.075v17.76a3.077 3.077 0 0 1-3.093 3.075H509.64a3.077 3.077 0 0 1-3.093-3.075v-17.76a3.077 3.077 0 0 1 3.093-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0907,
        stroke: '#000'
      }}
    />
    <path
      d='M511.13 1184h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H511.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 399.85 1080.2)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-3-9-2-2)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={32}
    >
      <path d='M132.61 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.789.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.118q.664.438 1.562.727.898.29 1.734.29.493 0 1.047-.165.555-.164.899-.484.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156t1.172.5q.562.375.851.906t.29 1.242q0 .969-.688 1.696-.68.718-1.61.906v.11q.376.062.86.265.484.195.82.492zM143.8 121.6h-7.875v-1.633l1.64-1.406q.829-.703 1.54-1.398 1.5-1.453 2.054-2.305.555-.86.555-1.852 0-.906-.601-1.414-.594-.515-1.665-.515-.71 0-1.539.25-.828.25-1.617.765h-.078v-1.64q.555-.274 1.477-.5.93-.227 1.797-.227 1.789 0 2.804.867 1.016.86 1.016 2.336 0 .664-.172 1.242-.164.57-.492 1.086-.305.485-.719.953-.406.47-.992 1.04-.836.82-1.727 1.593-.89.766-1.664 1.422h6.258z' />
    </g>
    <path
      d='M509.64 950.55h182.72a3.077 3.077 0 0 1 3.094 3.075v17.76a3.078 3.078 0 0 1-3.094 3.075H509.64a3.078 3.078 0 0 1-3.094-3.075v-17.76a3.078 3.078 0 0 1 3.094-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0906,
        stroke: '#000'
      }}
    />
    <path
      d='M511.13 953h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H511.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 399.85 849.21)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-3-9-2-3)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={36}
    >
      <path d='M132.61 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.789.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.118q.664.438 1.562.727.898.29 1.734.29.493 0 1.047-.165.555-.164.899-.484.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156t1.172.5q.562.375.851.906t.29 1.242q0 .969-.688 1.696-.68.718-1.61.906v.11q.376.062.86.265.484.195.82.492zM143.98 117.82q0 1.773-1.172 2.898-1.164 1.118-2.86 1.118-.859 0-1.562-.266-.703-.266-1.242-.79-.672-.648-1.04-1.718-.358-1.07-.358-2.578 0-1.547.328-2.742.336-1.195 1.062-2.125.688-.883 1.774-1.375 1.085-.5 2.53-.5.462 0 .774.039t.633.14v1.493h-.078q-.219-.117-.664-.219-.438-.11-.899-.11-1.68 0-2.68 1.055-1 1.047-1.163 2.836.656-.398 1.289-.601.64-.211 1.476-.211.742 0 1.305.14.57.133 1.164.547.688.477 1.031 1.203.352.727.352 1.766zm-1.586.063q0-.727-.219-1.204-.21-.476-.703-.828-.36-.25-.797-.328-.437-.078-.914-.078-.664 0-1.234.156-.57.157-1.172.485-.016.172-.023.336-.008.156-.008.398 0 1.234.25 1.953.257.711.703 1.125.36.344.773.508.422.156.914.156 1.133 0 1.781-.687.649-.696.649-1.992z' />
    </g>
    <path
      d='M509.64 899.55h182.72a3.078 3.078 0 0 1 3.094 3.075v17.76a3.078 3.078 0 0 1-3.094 3.075H509.64a3.078 3.078 0 0 1-3.094-3.075v-17.76a3.078 3.078 0 0 1 3.094-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0906,
        stroke: '#000'
      }}
    />
    <path
      d='M511.13 902h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H511.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 399.85 798.2)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-3-9-2-2-5)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={37}
    >
      <path d='M132.61 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.789.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.118q.664.438 1.562.727.898.29 1.734.29.493 0 1.047-.165.555-.164.899-.484.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156t1.172.5q.562.375.851.906t.29 1.242q0 .969-.688 1.696-.68.718-1.61.906v.11q.376.062.86.265.484.195.82.492zM143.84 111.71l-5.266 9.89h-1.672l5.602-10.265h-6.625v-1.368h7.961z' />
    </g>
    <path
      d='M509.64 848.55h182.72a3.078 3.078 0 0 1 3.094 3.075v17.76a3.078 3.078 0 0 1-3.094 3.075H509.64a3.078 3.078 0 0 1-3.094-3.075v-17.76a3.078 3.078 0 0 1 3.094-3.075z'
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 1.0906,
        stroke: '#000'
      }}
    />
    <path
      d='M511.13 851h14.559c1.178 0 2.126.948 2.126 2.126v14.559a2.121 2.121 0 0 1-2.126 2.126H511.13a2.121 2.121 0 0 1-2.126-2.126v-14.56c0-1.177.948-2.125 2.126-2.125z'
      style={{
        strokeLinejoin: 'round',
        strokeWidth: 0.68364
      }}
    />
    <g
      transform='matrix(.87979 0 0 .97638 399.85 747.21)'
      style={{
        fill: '#fff',
        shapeInside: 'url(#OverviewFrame_svg__rect441-3-3-9-2-2-5-7)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={38}
    >
      <path d='M132.61 116q.375.336.617.844t.242 1.312q0 .797-.289 1.461t-.812 1.156q-.586.547-1.383.813-.789.258-1.734.258-.97 0-1.907-.235-.937-.226-1.539-.5v-1.633h.118q.664.438 1.562.727.898.29 1.734.29.493 0 1.047-.165.555-.164.899-.484.36-.344.531-.758.18-.414.18-1.047 0-.625-.203-1.031-.196-.414-.547-.649-.352-.242-.852-.328-.5-.094-1.078-.094h-.703v-1.296h.547q1.187 0 1.89-.493.711-.5.711-1.453 0-.422-.18-.734-.18-.32-.5-.524-.335-.203-.718-.28-.383-.079-.867-.079-.743 0-1.578.266-.836.265-1.579.75h-.078v-1.633q.555-.273 1.477-.5.93-.234 1.797-.234.851 0 1.5.156t1.172.5q.562.375.851.906t.29 1.242q0 .969-.688 1.696-.68.718-1.61.906v.11q.376.062.86.265.484.195.82.492zM143.89 118.36q0 1.508-1.18 2.508-1.172 1-2.953 1-1.89 0-3.015-.977-1.118-.976-1.118-2.5 0-.969.563-1.75.562-.789 1.586-1.25v-.047q-.938-.5-1.39-1.093-.446-.594-.446-1.485 0-1.312 1.078-2.187t2.742-.875q1.742 0 2.781.836 1.04.836 1.04 2.125 0 .789-.493 1.554-.492.758-1.445 1.188v.047q1.094.468 1.672 1.156.578.687.578 1.75zm-1.852-5.68q0-.836-.648-1.328-.64-.5-1.64-.5-.985 0-1.618.469-.625.469-.625 1.266 0 .562.313.976.32.406.96.727.29.14.829.367.547.226 1.062.375.774-.516 1.07-1.07.297-.555.297-1.282zm.243 5.828q0-.718-.32-1.148-.313-.437-1.235-.875-.367-.172-.805-.32-.437-.149-1.164-.414-.703.382-1.133 1.039-.422.656-.422 1.484 0 1.055.727 1.742.727.688 1.844.688 1.14 0 1.82-.586.688-.586.688-1.61z' />
    </g>
    <text
      x={334.14}
      y={348.359}
      style={{
        fillOpacity: 0.37366,
        fill: '#fff',
        fontFamily: 'sans-serif',
        fontSize: '14.111px',
        fontWeight: 700,
        strokeLinejoin: 'round',
        strokeWidth: 0.5,
        stroke: '#000',
        textAlign: 'center',
        textAnchor: 'middle',
        writingMode: 'tb-rl'
      }}
      xmlSpace='preserve'
    />
    <path
      d='M453.804 270.227h423.642c2.414 0 4.357 1.404 4.357 3.148v184.817c0 1.744-1.943 3.148-4.357 3.148H453.804c-2.414 0-4.357-1.404-4.357-3.148V273.375c0-1.744 1.943-3.148 4.357-3.148z'
      style={{
        fill: '#ccc',
        stroke: '#fff',
        strokeWidth: 3.58049,
        strokeLinejoin: 'round'
      }}
    />
    <path
      d='M454.56 272.13H876.7c1.198 0 2.163.965 2.163 2.163v41.068a2.158 2.158 0 0 1-2.163 2.163H454.56a2.158 2.158 0 0 1-2.163-2.163v-41.068c0-1.198.965-2.163 2.163-2.163z'
      style={{
        fill: '#999',
        strokeLinejoin: 'round',
        strokeWidth: 1.7331
      }}
    />
    <path
      d='M877.81 317.85c-574.36 0-564.38.005-2.171 0zM877.81 365.15c-574.36 0-564.38.005-2.171 0z'
      style={{
        fill: 'none',
        strokeLinejoin: 'round',
        strokeWidth: 4.0581,
        stroke: '#fff'
      }}
    />
    <path
      d='M615.2 270.632c0 253.024.006 248.624 0 .956z'
      style={{
        fill: 'none',
        stroke: '#fff',
        strokeWidth: 3.56223,
        strokeLinejoin: 'round'
      }}
    />
    <path
      d='M526.45 270.89c0 252.823.007 248.431 0 .955z'
      style={{
        fill: 'none',
        stroke: '#fff',
        strokeWidth: 3.86392,
        strokeLinejoin: 'round'
      }}
    />
    <path
      d='M877.81 412.44c-574.36 0-564.38.005-2.171 0z'
      style={{
        fill: 'none',
        strokeLinejoin: 'round',
        strokeWidth: 4.0581,
        stroke: '#fff'
      }}
    />
    <path
      d='M1003 552.56v-7.292q6.125-.583 8.458-2.333 3.5-2.042 4.667-7.875h8.167v60.083h-9.917V552.56z'
      transform='translate(109.49 132.5) scale(.37124)'
      style={{
        shapeInside: 'url(#OverviewFrame_svg__rect3650-4-7)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={1}
    />
    <path
      d='M1004.2 590.77q-6.125-6.125-6.125-16.333h8.75q.875 8.458 5.25 10.792 4.667 2.333 8.167.292 4.375-2.625 4.666-7.292.584-6.417-3.791-8.458-2.334-1.167-8.167-1.167v-9.042q7.292 0 9.333-4.083 2.042-4.375.292-7.875-1.458-3.5-4.958-4.083-4.375-.875-7 2.333t-3.209 7.875h-7.875q.292-9.625 5.25-14.583 4.375-4.667 11.958-4.667 5.834 0 10.208 4.084 4.084 4.083 4.667 10.5.583 9.625-6.125 14 7.292 1.75 8.458 11.667 1.167 7.583-3.791 14-5.25 7-13.417 7-7.875 0-12.542-4.959z'
      transform='translate(111.09 180.02) scale(.37124)'
      style={{
        shapeInside: 'url(#OverviewFrame_svg__rect3650-4-5-6)',
        strokeLinejoin: 'round',
        strokeWidth: 15.118,
        whiteSpace: 'pre'
      }}
      aria-label={3}
    />
    <path
      d='M1003 589.6q-4.375-4.958-4.667-12.542h8.459q.875 4.667 4.083 7.292 3.5 2.625 7 1.458 6.125-1.75 7-9.042 1.167-7.583-4.083-11.667-2.625-2.041-6.125-1.458t-5.834 3.5h-9.041l4.666-32.083h27.125v9.917h-20.125l-2.041 11.958q9.041-5.542 16.625-.292 5.833 4.083 7.583 12.542 1.75 8.458-1.75 15.75-2.625 6.125-8.167 9.042-5.25 2.625-10.792 1.458-6.125-1.167-9.916-5.833z'
      transform='translate(110.994 227.285) scale(.37124)'
      style={{
        whiteSpace: 'pre',
        shapeInside: 'url(#OverviewFrame_svg__rect3650-4-5-3-0)',
        strokeWidth: 15.118,
        strokeLinejoin: 'round'
      }}
      aria-label={5}
    />
    <path
      d='M549.7 332.21h38.549c1.17 0 2.113.942 2.113 2.113v13.394c0 1.17-.943 2.113-2.113 2.113H549.7a2.108 2.108 0 0 1-2.113-2.113v-13.394c0-1.17.943-2.113 2.113-2.113z'
      style={{
        fill: '#0af',
        strokeLinejoin: 'round',
        strokeWidth: 0.34911,
        stroke: '#000'
      }}
    />
    <path
      d='M549.7 380.58h38.549c1.17 0 2.113.942 2.113 2.113v13.394c0 1.17-.943 2.113-2.113 2.113H549.7a2.108 2.108 0 0 1-2.113-2.113v-13.394c0-1.17.943-2.113 2.113-2.113z'
      style={{
        fill: 'red',
        strokeLinejoin: 'round',
        strokeWidth: 0.34911,
        stroke: '#000'
      }}
    />
    <path
      d='M549.7 428.195h38.55c1.17 0 2.112.942 2.112 2.112v13.394c0 1.17-.942 2.113-2.113 2.113H549.7a2.108 2.108 0 0 1-2.112-2.113v-13.394c0-1.17.942-2.112 2.112-2.112z'
      style={{
        fill: '#00b200',
        stroke: '#000',
        strokeWidth: 0.34911,
        strokeLinejoin: 'round'
      }}
    />
  </React.Fragment>
);

export default React.memo(SvgOverviewFrame);
